import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { merchantActions } from '../../../redux/merchants';
import { fetchStatistics } from './_redux/crud';
import OverviewTable from './OverviewTable'

export default function Main() {
    const [allMerchantsStatistics, setAllMerchantsStatistics] = useState([])
    const [prevMerchantsStatistics, setPrevMerchantsStatistics] = useState([])
    const { filter, allMerchants } = useSelector(
        state => ({
            filter: state.merchants.filter,
            allMerchants: state.merchants.merchants,
        }),
    );
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchAll = async () => {
            if (!filter.merchantId || !filter.to || !filter.from || !allMerchants.length) {
                return;
            }
            const data = await fetchStatistics({
                to: filter.to,
                from: filter.from,
                merchantId: filter.merchantId,
            });
            setAllMerchantsStatistics(data.statistics);
            setPrevMerchantsStatistics(data.prevStatistics);
            dispatch(
                merchantActions.updateLoading({
                    isCalendarLoading: false
                }),
            );
        }
        fetchAll();
    }, [filter, dispatch, allMerchants.length]);

    return (<>
        <OverviewTable allMerchantsStatistics={allMerchantsStatistics} prevMerchantsStatistics={prevMerchantsStatistics} />
    </>
    )
}
